<div *ngIf="checkFormTypeService.isReactiveForm(model, controlName); else template">
  <label *ngIf="label" class="seds-mb-2">{{ label }}</label>
  <mat-radio-group [attr.aria-label]="label" class="{{ listPosition }} default" [formControl]="formControl">
    <mat-radio-button *ngFor="let item of items" [value]="item" disableRipple>
      {{ item }}
    </mat-radio-button>
  </mat-radio-group>
</div>

<ng-template #template>
  <label *ngIf="label" class="seds-mb-2">{{ label }}</label>
  <mat-radio-group
    [attr.aria-label]="label"
    class="{{ listPosition }} default"
    [disabled]="disabled"
    [(ngModel)]="model">
    <mat-radio-button (change)="emitValue($event)" *ngFor="let item of items" [value]="item" disableRipple>
      {{ item }}
    </mat-radio-button>
  </mat-radio-group>
</ng-template>
